/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

import NavBar from '../../components/NavBar';
import Load from '../../components/Load';

import { getToken } from '../../api/auth';
import calendarUSAMask from '../../utils/masks/calendarUSAMask';

import { FertilizationsFetch } from '../../api/services/NotebookAPI';

export default function Claim({ history }) {
  const token = getToken();
  const [fertilizations, setFertilizations] = useState([]);
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function getFertilizations() {
      setIsLoad(true);
      try {
        const resultFertilizations = await FertilizationsFetch(token);
        console.log('getFertilizations | resultFertilizations: ', resultFertilizations);
        setIsLoad(false);
        setMessageWarning(resultFertilizations.message);
        setIsSuccessMessage(resultFertilizations.isSuccess);
        if (resultFertilizations.isSuccess) {
          setFertilizations(resultFertilizations.fertilizations);
        }
      } catch (error) {
        console.log('getFertilizations | error: ', error);
        setIsSuccessMessage(false);
        setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
        setIsLoad(false);
      }
    }

    getFertilizations();
  }, [history, token]);

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Histórico de Compostagens
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          <button
            className="form__button"
            type="button"
            // eslint-disable-next-line no-undef
            onClick={() => navigate('/notebook/fertilizing/create', { replace: true })}
          >
            Registrar Compostagem
          </button>

          {fertilizations.map((fertilizing) => (
            <div
              className="detail__container"
              onClick={() => navigate(`/notebook/fertilizing/${fertilizing.id}`, { replace: true })}
              aria-hidden="true"
            >
              <p className="detail__value">
                {fertilizing.stack_number}
              </p>
              <p className="detail__value">
                {calendarUSAMask(fertilizing.created)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
